import { ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from '@unesp/core'
import { RegistroAcademico } from '../features/publico/home/registro-academico-selecionar/registro-academico'

export const getMenuAlunoRegular = (registroAcademico: RegistroAcademico): UnespCoreMenuItem[] => {
  let hidden = false
  try {
    hidden = !registroAcademico.isMatriculado
  } catch (e) {}

  const menu: UnespCoreMenuItem[] = [
    // ALUNO_REGULAR
    {
      displayName: 'Meus Dados',
      iconName: 'person',
      roles: ['ALUNO_REGULAR'],
      order: 1,
      children: [
        {
          displayName: 'Atualização Cadastral',
          iconName: 'description',
          roles: ['ALUNO_REGULAR'],
          order: 1,
          route: 'discente/meus-dados/dados-cadastrais',
        },
        {
          displayName: 'Horário de Aulas',
          iconName: 'schedule',
          roles: ['ALUNO_REGULAR'],
          order: 2,
          route: 'discente/meus-dados/horario-aulas',
        },
        {
          displayName: 'Situação Acadêmica',
          iconName: 'info',
          roles: ['ALUNO_REGULAR'],
          order: 3,
          route: 'discente/meus-dados/situacao-academica',
        },
        {
          displayName: 'Aproveitamento de Créditos',
          iconName: 'change_circle',
          roles: ['ALUNO_REGULAR'],
          order: 4,
          route: 'discente/meus-dados/aproveitamento-creditos',
        },
        {
          displayName: 'Atividades Complementares',
          iconName: 'file_copy',
          roles: ['ALUNO_REGULAR'],
          order: 5,
          route: 'discente/meus-dados/atividades-complementares',
        },
        {
          displayName: 'Proficiência em Línguas',
          iconName: 'language',
          roles: ['ALUNO_REGULAR'],
          order: 6,
          route: 'discente/meus-dados/proficiencia',
        },
        {
          displayName: 'Ocorrências',
          iconName: 'event_available',
          roles: ['ALUNO_REGULAR'],
          order: 7,
          route: 'discente/meus-dados/ocorrencias',
        },
        {
          displayName: 'Bolsas/Auxílios',
          iconName: 'work',
          roles: ['ALUNO_REGULAR'],
          order: 8,
          route: 'discente/meus-dados/bolsas',
        },
        {
          displayName: 'Prazos',
          iconName: 'alarm',
          roles: ['ALUNO_REGULAR'],
          order: 9,
          route: 'discente/meus-dados/prazos',
        },
        {
          displayName: 'Prazos Cumpridos',
          iconName: 'check_circle',
          roles: ['ALUNO_REGULAR'],
          order: 10,
          route: 'discente/meus-dados/prazos-cumpridos',
        },
        {
          displayName: 'Mobilidades',
          iconName: 'travel_explore',
          roles: ['ALUNO_REGULAR'],
          order: 11,
          route: 'discente/meus-dados/mobilidades',
        },
      ],
    },
    {
      displayName: 'Consultas',
      iconName: 'search',
      roles: ['ALUNO_REGULAR'],
      order: 2,
      children: [
        {
          displayName: 'Dados do Curso',
          iconName: 'event_note',
          roles: ['ALUNO_REGULAR'],
          order: 1,
          route: 'discente/consulta/dados-curso',
        },
        {
          displayName: 'Disciplinas do Programa',
          iconName: 'format_list_bulleted',
          roles: ['ALUNO_REGULAR'],
          order: 2,
          route: 'discente/consulta/disciplinas-programa',
        },
        {
          displayName: 'Minhas Disciplinas',
          iconName: 'list',
          roles: ['ALUNO_REGULAR'],
          order: 3,
          route: 'discente/consulta/minhas-disciplinas',
        },
        {
          displayName: 'Calendário Escolar',
          iconName: 'calendar_month',
          roles: ['ALUNO_REGULAR'],
          route: 'discente/consulta/calendario-escolar',
          order: 4,
        },
      ],
    },
    {
      displayName: 'Projeto',
      iconName: 'receipt_long',
      roles: ['ALUNO_REGULAR'],
      route: 'discente/projeto-pesquisa',
      order: 3,
    },
    {
      displayName: 'Intercâmbio',
      iconName: 'travel_explore',
      roles: ['ALUNO_REGULAR'],
      route: 'discente/intercambio',
      order: 4,
    },
    {
      displayName: 'Matrícula',
      iconName: 'edit_calendar',
      roles: ['ALUNO_REGULAR'],
      order: 5,
      hidden: hidden,
      children: [
        {
          displayName: 'Matrícula Regular',
          iconName: 'arrow_right',
          roles: ['ALUNO_REGULAR'],
          order: 1,
          route: 'discente/matricula/matricula-regular',
        },
        {
          displayName: 'Acompanhamento Matrícula Regular',
          iconName: 'arrow_right',
          roles: ['ALUNO_REGULAR'],
          order: 2,
          route: 'discente/matricula/acompanhamento-matricula-regular',
        },
        {
          displayName: 'Matrícula Portfólio',
          iconName: 'arrow_right',
          roles: ['ALUNO_REGULAR'],
          order: 3,
          route: 'discente/matricula/matricula-portfolio',
        },
        {
          displayName: 'Acompanhamento Matrícula Portfólio',
          iconName: 'arrow_right',
          roles: ['ALUNO_REGULAR'],
          order: 4,
          route: 'discente/matricula/acompanhamento-matricula-portfolio',
        },
      ],
    },
    {
      displayName: 'Documentos',
      iconName: 'folder_open',
      roles: ['ALUNO_REGULAR'],
      order: 6,
      children: [
        {
          displayName: 'Nova Solicitação',
          iconName: 'add_circle',
          roles: ['ALUNO_REGULAR'],
          order: 1,
          route: 'discente/documentos/nova-solicitacao',
        },
        {
          displayName: 'Histórico de Solicitações',
          iconName: 'task',
          roles: ['ALUNO_REGULAR'],
          order: 2,
          route: 'discente/documentos/historico-solicitacoes',
        },
      ],
    },
    {
      displayName: 'Mensagens',
      iconName: 'mail',
      roles: ['ALUNO_REGULAR'],
      order: 7,
      addBottomDivider: true,
      children: [
        {
          displayName: 'Recebidas',
          iconName: 'mark_email_read',
          roles: ['ALUNO_REGULAR'],
          order: 1,
          route: 'discente/mensagens/recebidas',
        },
      ],
    },
    {
      displayName: 'Autenticidade de documento',
      iconName: 'qr_code_scanner',
      roles: [ROLE_WILDCARD_PUBLIC],
      route: 'autenticidade-documento',
      order: 998,
    },
    // COMUN
    {
      displayName: 'Voltar ao portal',
      iconName: 'home',
      roles: [ROLE_WILDCARD_PUBLIC],
      route: 'voltar-portal',
      order: 1000,
    },
  ]

  return menu.filter(item => !item.hidden)
}
